import { Paperclip, RefreshCw } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { api, eur, errMsg, PREP } from './api';

// Rattacher une facture à une dépense déjà enregistrée : justificatif seul, ou alignement du montant (gérant / administrateur)
export function LinkExistingDialog({ link, run, onClose }) {
    if (!link) return null;
    const { id, montant, vehicle, frais: f, persist } = link;
    const diff = Math.abs(Number(f.montant_ttc || 0) - Number(montant || 0)) > 0.01;
    const body = { vehicle_id: vehicle.id, frais_idx: f.idx, expected_nom: f.nom ?? '' };
    const go = (fn, msg) => {
        onClose();
        if (link.after) { fn().then(() => { toast.success(msg); link.after(); }).catch(e => toast.error(errMsg(e))); return; }
        run(async () => { if (persist) await persist(); return fn(); }, msg);
    };
    return (
        <Dialog open onOpenChange={o => !o && onClose()}>
            <DialogContent className="max-w-md bg-white" data-testid="link-existing-dialog">
                <DialogHeader><DialogTitle>Rattacher à une dépense existante</DialogTitle></DialogHeader>
                <div className="text-[13px] text-gray-700 space-y-2">
                    <p>Dépense « <b>{f.nom || 'Frais'}</b> » du dossier <span className="font-mono">{vehicle.immatriculation}</span> : <b>{eur(f.montant_ttc)}</b></p>
                    <p>Facture : <b>{eur(montant)}</b></p>
                    {diff
                        ? <p className="rounded-lg bg-amber-50 border border-amber-200 text-amber-900 px-3 py-2 text-[12px]" data-testid="link-existing-diff">Les montants diffèrent de {eur(Math.abs(Number(f.montant_ttc || 0) - Number(montant || 0)))}. Vous pouvez garder la dépense telle quelle (justificatif seul) ou aligner son montant sur la facture : l'ancienne valeur reste tracée.</p>
                        : <p className="text-[12px] text-emerald-700">Montants identiques : aucune nouvelle dépense, aucune marge modifiée.</p>}
                </div>
                <DialogFooter className="flex-col sm:flex-row gap-2">
                    <Button variant="outline" onClick={onClose} data-testid="link-existing-cancel">Annuler</Button>
                    {diff && !PREP.on && <Button variant="outline" onClick={() => go(() => api.replaceExisting(id, body), `Montant aligné : ${eur(f.montant_ttc)} → ${eur(montant)}`)} data-testid="link-existing-align"><RefreshCw className="w-4 h-4 mr-1.5" />Aligner le montant</Button>}
                    <Button onClick={() => go(() => api.linkExisting(id, body), 'Justificatif rattaché — aucune dépense créée')} className="bg-[#6366F1] hover:bg-[#4F46E5] text-white" data-testid="link-existing-proof"><Paperclip className="w-4 h-4 mr-1.5" />Justificatif seul</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
